import styled from "styled-components";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo_1.png";
import loginIcon from "../assets/images/common/icon_login.png";

const HeaderContainer = styled.header`
    width: 1000px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background: #FFFFFF;
`;

const Logo = styled.div`
    img {
        margin-top: 15px;
        height: 50px;
    }

    @media all and (max-width: 720px) {
        img {
            height: 40px;
        }
    }
`;

const HeaderMenu = styled.ul`
    float: right;
    padding: 1rem 0;
    padding-right: 4rem;
    font-family: "PlusJakartaSansRegular";

    ::after {
        display: block;
        clear: both;
        content: "";
    }
    > li {
        float: left;
        position: relative;
    }
    > li > a {
        position: relative;
        display: block;
        height: 2.9rem;
        line-height: 2.9rem;
        padding: 0 1.25rem;
        font-size: 1rem;
        font-weight: 500;
        color: #486284;
        text-decoration: none;
    }
    > li.on > a {
        color: #1a202c;
        font-weight: bold;
        font-family: "PlusJakartaSansSemiBold";
    }
    > li.on > a::after {
        display: block;
        clear: both;
        content: "";
        position: absolute;
        bottom: 0;
        left: 1rem;
        right: 1rem;
        height: 0.1rem;
        background: #1a202c;
    }

    @media all and (max-width: 720px) {
        padding-right: 2rem;
        > li > a {
            padding: 0 0.5rem;
            font-size: 13px;
        }
    }
`;

const DropdownMenu = styled.ul`
    position: absolute;
    top: 100%;
    left: 0;
    width: 200px;
    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: ${props => (props.show ? "block" : "none")};
    z-index: 999;
    padding: 0.5rem 0;
     li {
        position: relative; /* ★ 추가 */
    }   
    > li {
        display: block;
        width: 100%;
    }
    
    > li > a {
        display: block;
        padding: 0.5rem 1.25rem;
        color: #486284;
        text-decoration: none;
        font-size: 0.9rem;
    }
    
    > li > a:hover {
        background: #f8f9fa;
        color: #1a202c;
    }
`;

export const Navbar = ({ mode }) => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [activeSubDropdown, setActiveSubDropdown] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    // 로그인 상태 및 권한 체크
    useEffect(() => {
        const checkAuthStatus = () => {
            const token = localStorage.getItem('access_token');
            const userRole = localStorage.getItem('user_role') || sessionStorage.getItem('user_role');
            console.log('사용자 권한:', userRole); // 디버깅용
            setIsLoggedIn(!!token);
            setIsAdmin(userRole === 'admin');
        };

        // 초기 로드 시 체크
        checkAuthStatus();

        // storage 이벤트 리스너로 변경 감지
        const handleStorageChange = () => {
            checkAuthStatus();
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const handleMouseEnter = (menu) => {
        setActiveDropdown(menu);
        setActiveSubDropdown(null);
    };

    const handleMouseLeave = () => {
        setActiveDropdown(null);
        setActiveSubDropdown(null);
    };
    const handleSubMouseEnter = (submenu) => {
        setActiveSubDropdown(submenu);
    };

    const handleSubMouseLeave = () => {
        setActiveSubDropdown(null);
    };

    const handleAdminPageClick = (e) => {
        e.preventDefault();
        if (isAdmin) {
            navigate('/admin');
        } else {
            alert("관리자만 접근할 수 있습니다.");
            navigate('/home');
        }
    };

    const handleLogout = (e) => {
        e.preventDefault();

        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_role');
        sessionStorage.removeItem('user_role');

        // 상태 즉시 업데이트
        setIsLoggedIn(false);
        setIsAdmin(false);

        window.location.href = '/home';
    };

    useEffect(() => {
        const handleClickOutside = () => {
            setActiveDropdown(null);
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <HeaderContainer>
            <Logo>
                <a href="/home">
                    <img src={logo} alt="Logo" />
                </a>
            </Logo>
            <div className="inner">
                <HeaderMenu>
                    <li
                        className={mode === "introduction" ? "on" : ""}
                        onMouseEnter={() => handleMouseEnter("introduction")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <a href="/introduction/greeting">총학생회 소개</a>
                        <DropdownMenu show={activeDropdown === "introduction"}>
                            <li><a href="/introduction/greeting">총학생회장단 인사말</a></li>
                            <li><a href="/introduction/executive">중앙집행위원회 소개</a></li>
                            <li><a href="/introduction/committees">산하위원회 소개</a></li>
                            <li><a href="/introduction/location">오시는 길</a>
                            </li>
                        </DropdownMenu>
                    </li>
                    <li
                        className={mode === "news" ? "on" : ""}
                        onMouseEnter={() => handleMouseEnter("news")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <a href="/news/student-council">총학생회 소식</a>
                        <DropdownMenu show={activeDropdown === "news"}>
                            <li
                                onMouseEnter={() => handleSubMouseEnter('news-submenu1')}
                                onMouseLeave={handleSubMouseLeave}
                                style={{ position: 'relative' }}
                            >
                                <a href="/news/student-council">중앙집행위원회 소식</a>

                                {/* 서브 드랍다운 */}
                                <DropdownMenu
                                    show={activeSubDropdown === 'news-submenu1'}
                                    style={{
                                        top: '0',
                                        left: '100%',
                                        position: 'absolute'
                                    }}
                                >
                                    <li><a href="/news/edu-council">교육자치국</a></li>
                                    <li><a href="/news/unity-council">연대사업국</a></li>
                                    <li><a href="/news/life-council">일상사업국</a></li>
                                    <li><a href="/news/strategy-council">전략정책국</a></li>
                                    <li><a href="/news/promo-council">홍보소통국</a></li>
                                    <li><a href="/news/accounting">회계사무국</a></li>
                                </DropdownMenu>
                            </li>

                            <li
                                onMouseEnter={() => handleSubMouseEnter('news-submenu2')}
                                onMouseLeave={handleSubMouseLeave}
                                style={{ position: 'relative' }}
                            >
                                <a href="/news/culture-committee">산하위원회 소식</a>

                                {/* 서브 드랍다운 */}
                                <DropdownMenu
                                    show={activeSubDropdown === 'news-submenu2'}
                                    style={{
                                        top: '0',
                                        left: '100%',
                                        position: 'absolute'
                                    }}
                                >
                                    <li><a href="/news/culture-committee">문화위원회 소식</a></li>
                                    <li><a href="/news/graduation-committee">졸업준비위원회 소식</a></li>
                                    <li><a href="/news/welfare-committee">학생복지위원회 소식</a></li>
                                    <li><a href="/news/human-rights-committee">학생인권위원회 소식</a></li>
                                </DropdownMenu>
                            </li>

                            <li><a href="/news/calendar">연간 일정</a></li>

                        </DropdownMenu>
                    </li>

                    <li
                        className={mode === "student-autonomy" ? "on" : ""}
                        onMouseEnter={() => handleMouseEnter("student-autonomy")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <a href="/student-autonomy/activity">학생자치</a>
                        <DropdownMenu show={activeDropdown === "student-autonomy"}>
                            <li><a href="/student-autonomy/activity">자치활동보고</a></li>
                            <li><a href="/student-autonomy/council-rules">총학생회 회칙 및 세칙</a></li>
                            <li><a href="/student-autonomy/central-committee">중앙운영위원회 회의록</a></li>
                            <li><a href="/student-autonomy/department-rules">단과대학 학생 회칙 및 세칙</a></li>

                        </DropdownMenu>
                    </li>
                    <li
                        className={mode === "convenience-info" ? "on" : ""}
                        onMouseEnter={() => handleMouseEnter("convenience-info")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <a href="/convenience-info/affiliate">편의정보</a>
                        <DropdownMenu show={activeDropdown === "convenience-info"}>
                            <li><a href="/convenience-info/affiliate">제휴 안내</a></li>
                            <li><a href="/convenience-info/resident-business">상주 사업 안내</a></li>
                            <li><a href="/convenience-info/space-adjustment">공간조정회의</a></li>
                        </DropdownMenu>
                    </li>
                    {isLoggedIn && (
                        <li
                            className={mode === "mypage" ? "on" : ""}
                            onMouseEnter={() => handleMouseEnter("mypage")}
                            onMouseLeave={handleMouseLeave}
                        >
                            <a href="/mypage/edit">내정보</a>
                            <DropdownMenu show={activeDropdown === "mypage"}>
                                <li><a href="/mypage/edit">내정보수정</a></li>
                                {/* <li><a href="/mypage/withdraw">회원탈퇴</a></li> */}
                            </DropdownMenu>
                        </li>
                    )}
                    <li className={mode === "login" ? "on" : ""}>
                        {isLoggedIn ? (
                            <a href="#" onClick={handleLogout} style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={loginIcon} alt="로그아웃 아이콘" style={{ marginRight: '5px', height: '16px' }} />
                                로그아웃
                            </a>
                        ) : (
                            <a href="/intro/login" style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={loginIcon} alt="로그인 아이콘" style={{ marginRight: '5px', height: '16px' }} />
                                로그인
                            </a>
                        )}
                    </li>
                    {/* 관리자만 보이는 메뉴 */}
                    {isAdmin && (
                        <li className={mode === "admin" ? "on" : ""}
                            onMouseEnter={() => handleMouseEnter("admin")}
                            onMouseLeave={handleMouseLeave}
                        >
                            <a href="/admin/authorization-user" style={{ display: 'flex', alignItems: 'center' }}>
                                Admin 페이지
                            </a>
                            <DropdownMenu show={activeDropdown === "admin"}>
                                <li><a href="/admin/authorization-user">회원 승인</a></li>
                                <li><a href="/admin/modify-schedule">일정표 변경</a></li>
                            </DropdownMenu>
                        </li>
                    )}
                </HeaderMenu>
            </div>
        </HeaderContainer>
    );
};